import type { RouteRecordRaw } from 'vue-router';
import { SERVICE_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const serviceManagementRoutes: RouteRecordRaw = {
  path: '/service-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: SERVICE_ROUTE_NAME.LIST_SERVICE,
      path: '',
      component: () => import('./ServiceManagement.vue'),
    },
  ],
};

export const serviceRedirects: RouteRecordRaw[] = [
  { path: '/service', redirect: { name: SERVICE_ROUTE_NAME.LIST_SERVICE } },
  { path: '/service/services', redirect: { name: SERVICE_ROUTE_NAME.LIST_SERVICE } },
];
